function detectSocialMedia() {
  detectTwitter();
  detectFacebook();
}

function detectTwitter() {
  // No good way to detect whether you are logged in to twitter.
  // Now we base it on whether you have taken any twitter action in the past
  window.socialMediaStatuses.twitter = window.likely_twitter;
};

function detectFacebook() {
  // Check if the user is logged in to Facebook
  // Important Note: Only do this if Facebook Graph API has been enabled!
  // Some orgs may not want to use Facebook APIs, and others may require consent from users before using such APIs!
  if (trackersFacebookGraphApi.enabled) {
    FB.getLoginStatus((response) => { // eslint-disable-line no-undef
      if (response.status !== 'unknown') {
        window.socialMediaStatuses.facebook = true;
      }
    });
  }

  // If Facebook API is not enabled or the user isn't logged in,
  // look at whether they've taken facebook actions in the past
  if (!window.socialMediaStatuses.facebook) {
    window.socialMediaStatuses.facebook = window.likely_facebook;
  }
};


/*** EXPORTS FROM exports-loader ***/
exports["detectSocialMedia"] = (detectSocialMedia);
exports["detectTwitter"] = (detectTwitter);
exports["detectFacebook"] = (detectFacebook);